import { IApiResponse, IFixResponse, api } from '../index';

import generateQuery from '../../utils/generateQuery';
import axios, { AxiosResponse } from 'axios';

type IDadosLogin = {
  email?: string;
  password?: string;
  tokenGov?: string;
  accessTokenGoogle?: string;
  cod_parque_servico?: number;
  cod_municipio?: number;
};

interface IFormData {
  cod_municipio?: string;
  nom_cpf?: string;
  nom_email?: string;
  nom_fone1?: string;
  nom_nome_completo?: string;
  nom_senha?: string;
  recaptchaResponse?: string;
  nom_email_google?: string;
  nom_email_gov?: string;
}

export async function loginReclamante(dadosLogin: IDadosLogin): Promise<IApiResponse> {
  const res: IApiResponse = await api.post(`/auth/complainer/login_cidadao`, dadosLogin);

  return res;
}

interface IResetPasswordData {
  email: string;
}

interface INewPasswordData {
  token: string;
  new_password: string;
  verify_password: string;
}

export async function resetPasswordReclamante(dadosReset: IResetPasswordData): Promise<IApiResponse> {
  const res: IApiResponse = await api.post(`/auth/v1/complainer/forgot_password`, dadosReset);

  return res;
}

export async function newPasswordReclamante(dadosReset: INewPasswordData): Promise<IApiResponse> {
  const res: IApiResponse = await api.post(`/auth/v1/complainer/reset_password`, dadosReset);

  return res;
}

export async function createReclamante(dadosLogin: IFormData | undefined): Promise<IApiResponse> {
  const res: IApiResponse = await api.post(`/auth/v1/complainer/create`, dadosLogin);

  return res;
}

interface IetOcorrenciasByIdReclamanteOptions {
  cod_parque_servico?: number;
  cod_municipio?: number;
}

export async function getOcorrenciasByIdReclamante(
  cod_reclamante: number,
  options: IetOcorrenciasByIdReclamanteOptions = {},
): Promise<IFixResponse> {
  const query = generateQuery({
    ...options,
    cod_reclamante,
    dados_reduzidos: true,
  });

  const res: IApiResponse = await api.get(`/management/app_prefeitura/ocorrencia/listar/reclamante?${query}`);

  if (res.failed) {
    if (res.message) {
      return { err: res.message, data: null };
    }
    return { err: res.err, data: null };
  }

  const responseData = Array.isArray(res.data?.data) ? res.data.data : res.data;
  const data = (responseData || []).map((item) => ({
    ...item,
    cod_status_ocorrencia: item.cod_status_ocorrencia ?? item.cod_status_ocorrencia_ponto_servico,
    dth_inclusao_ocorrencia_ponto_servico: item.dth_inclusao_ocorrencia_ponto_servico ?? item.dth_inclusao,
    seq_atendimento_ponto_servico: item.seq_atendimento_ponto_servico ?? item.cod_atendimento_ponto_servico,
    seq_avaliacao_atendimento: item.seq_avaliacao_atendimento ?? (item.is_avaliada ? 1 : undefined),
  }));

  return { err: null, resp: data };
}

export async function cancelarOcorrencia(seq_ocorrencia_ponto_servico: number) {
  return (await api.put(`/management/ocorrencia/cancelar-ops/${seq_ocorrencia_ponto_servico}`, {
    nom_observacao: null,
  })) as IApiResponse;
}

export interface ITipoOcorrencia {
  cod_prioridade_ocorrencia: number;
  nom_descricao: string;
  seq_tipo_ocorrencia: number;
}

export async function getTipoOcorrencia(
  cod_parque_servico?: number,
  is_iframe?: boolean,
): Promise<IApiResponse<ITipoOcorrencia[]>> {
  return await api.get(`/management/ocorrencia/tipo/ocorrencia/listar/tipos`, {
    params: { cod_parque_servico, is_iframe },
  });
}

export async function getTipoOcorrenciaAnonimo(
  cod_parque_servico?: number,
  is_iframe?: boolean,
): Promise<IApiResponse<ITipoOcorrencia[]>> {
  return await api.get(`/external/ocorrencia/tipo/ocorrencia/listar/tipos`, {
    params: { cod_parque_servico, is_iframe },
  });
}

export async function reclamanteLogout(currentToken: string | any): Promise<any> {
  const res: IApiResponse = await api.get('/auth/complainer/logout', {
    headers: {
      'x-access-token': currentToken,
    },
  });

  return res;
}

export async function verifyTokenPasswordReclamante(token: string): Promise<IApiResponse> {
  const res: IApiResponse = await api.get(`/auth/complainer/verify_token_password?token=${token}`);

  return res;
}

export async function logoutGov() {
  return await axios.post(
    `https://sso.staging.acesso.gov.br/logout?post_logout_redirect_uri=${process.env.REACT_APP_REDIRECT_LOGOUT_URL_GOV}`,
  );
}

export const checkIfComplainerExistsSocialRequest = ({
  value,
  socialType,
}: {
  value?: string;
  socialType?: string;
}): Promise<AxiosResponse> => {
  return api.get('/external/app_prefeitura/reclamante/verificar-reclamante-existe-social', {
    params: {
      value,
      socialType,
    },
  });
};
